export const Colors = {
  GAME_BADGE_BLOOD_RED: "#fb0020",
  GAME_BADGE_PURPLE: "#d381c3",
  GAME_BADGE_TEAL: "#76c7b7",
  GAME_BADGE_GREEN: "#a2c659",
  GAME_BADGE_ORANGE: "#fd6d24",
  GAME_BADGE_YELLOW: "#fda331",
  GAME_BADGE_BLUE: "#6fb3d2",
  GAME_BADGE_BROWN: "#b3643c",
  GAME_BADGE_CREAM: "#FFEEDB",
  GAME_BADGE_PINK_RED: "#F31260",
};
